import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "summaryReports";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
